import { SkeletonLoader } from "@saviynt/design-system";

interface TableSkeletonLoaderProps {
  rows?: number;
}

export default function TableSkeletonLoader({
  rows = 5,
}: TableSkeletonLoaderProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      {Array.from({ length: rows }).map((_, index) => (
        <SkeletonLoader
          key={index}
          shape="square"
          animationStyle="wave"
          height="1.5rem"
          width="100%"
        />
      ))}
    </div>
  );
}
